import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PRICING_PLANS } from '../../../config/pricing/plans';
import { Check } from 'lucide-react';

export function PricingSection() {
  const plan = PRICING_PLANS.ENTERPRISE;

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Enterprise Resume Matching Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Power your hiring with AI-driven resume analysis. Built for large organizations that need scale, security, and precision.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full border border-gray-200 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                Most Popular
              </span>
            </div>
            
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
              <p className="text-gray-600 mb-4">Enterprise solution for large organizations</p>
              <div className="mb-4">
                <span className="text-4xl font-bold text-gray-900">Contact Sales</span>
                <span className="text-gray-500 ml-2">for pricing</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8">
              {plan.features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <Check className="h-5 w-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>

            <Link to="/pricing" className="block">
              <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium transition-colors">
                Get Enterprise Pricing
              </Button>
            </Link>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Perfect for large organizations with 100+ users
          </p>
          <div className="flex justify-center space-x-8 text-sm text-gray-500">
            <span>✓ Custom integrations</span>
            <span>✓ Dedicated support</span>
            <span>✓ SLA guarantees</span>
          </div>
        </div>
      </div>
    </section>
  );
}